// Carlyle Avenue — surface the typed-state result count on the "View all results" CTA (additive).
//
// The predictive-search footer CTA (snippets/search-modal.liquid, ref="viewAllButton")
// lives OUTSIDE the section markup that predictive-search.js morph()s on each keystroke,
// so its label can't be server-rendered with the count. The count IS rendered by the
// section, onto the results container as `data-search-results-count`
// (sections/predictive-search.liquid). This layer reads that attribute on every morph and
// rewrites the button label from its `data-count-template` ("View all N results"),
// falling back to the button's original plain text whenever the count is 0/unknown.
//
// Deliberately additive (same convention as ca-search-a11y.js / ca-search-discovery.js):
// no fork of predictive-search.js, and NO live region — the SR count announcement already
// lives in sections/predictive-search.liquid (role="status"); this only touches the
// visible button so there's no double-announce.

const COUNT_TOKEN = '__count__';

function setup(root) {
  const button = root.querySelector('[ref="viewAllButton"]');
  const results = root.querySelector('[ref="predictiveSearchResults"]');
  if (!(button instanceof HTMLElement) || !results) return;

  // The plain "View all" string the button ships with — the graceful fallback for
  // 0/unknown counts. Captured once before any rewrite.
  const fallbackLabel = (button.textContent || '').trim();
  const template = button.dataset.countTemplate || '';

  const sync = () => {
    const raw = results.querySelector('[data-search-results-count]')?.getAttribute('data-search-results-count');
    const count = raw ? Number.parseInt(raw, 10) : 0;

    if (template && Number.isFinite(count) && count > 0) {
      button.textContent = template.replace(COUNT_TOKEN, String(count));
    } else {
      button.textContent = fallbackLabel;
    }
  };

  // childList+subtree catches a morph that replaces the results subtree; attributeFilter on
  // data-search-results-count also catches a morph that mutates ONLY the count attribute on an
  // otherwise-identical subtree (would leave a stale label without this).
  const observer = new MutationObserver(sync);
  observer.observe(results, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-search-results-count'],
  });

  sync();
}

function init() {
  for (const root of document.querySelectorAll('predictive-search-component')) setup(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
